import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=5e58c0e1&"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e58c0e1')) {
      api.createRecord('5e58c0e1', component.options)
    } else {
      api.reload('5e58c0e1', component.options)
    }
    module.hot.accept("./ChangePasswordModal.vue?vue&type=template&id=5e58c0e1&", function () {
      api.rerender('5e58c0e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/accessmanagement/ChangePasswordModal.vue"
export default component.exports